import states from '../../configs/states';

export const EXCHANGE_AND_PROGRAMS_NAMES = {
    [states.GEORGIA]: {
        en: {
            exchangeName: 'Georgia Access',
            exchangeMedicaid: 'Medicaid',
            exchangeChip: 'PeachCare for Kids(R)',
            exchangeMedicaidOrChip: 'Medicaid or PeachCare for Kids(R)',
            exchangeMedicaidSlashChip: 'Medicaid/PeachCare for Kids(R)',
        },
        es: {
            exchangeName: 'Georgia Access',
            exchangeMedicaid: 'Medicaid',
            exchangeChip: 'PeachCare para Niños(R)',
            exchangeMedicaidOrChip: 'Medicaid or PeachCare para Niños(R)',
            exchangeMedicaidSlashChip: 'Medicaid/PeachCare para Niños(R)',
        },
    },
    [states.GETINSURED]: {
        en: {
            exchangeName: 'Getinsured',
            exchangeMedicaid: 'Medicaid',
            exchangeChip: 'CHIP',
            exchangeMedicaidOrChip: 'Medicaid or CHIP',
            exchangeMedicaidSlashChip: 'Medicaid/CHIP',
        },
        es: {
            exchangeName: 'Getinsured',
            exchangeMedicaid: 'Medicaid',
            exchangeChip: 'CHIP',
            exchangeMedicaidOrChip: 'Medicaid or CHIP',
            exchangeMedicaidSlashChip: 'Medicaid/CHIP',
        },
    },
    [states.IDAHO]: {
        en: {
            exchangeName: 'Your Health Idaho',
            exchangeMedicaid: 'Medicaid',
            exchangeChip: 'CHIP',
            exchangeMedicaidOrChip: 'Medicaid or CHIP',
            exchangeMedicaidSlashChip: 'Medicaid/CHIP',
        },
        es: {
            exchangeName: 'Your Health Idaho',
            exchangeMedicaid: 'Medicaid',
            exchangeChip: 'CHIP',
            exchangeMedicaidOrChip: 'Medicaid or CHIP',
            exchangeMedicaidSlashChip: 'Medicaid/CHIP',
        },
    },
    [states.ILLINOIS]: {
        en: {
            exchangeName: 'Get Covered Illinois',
            exchangeMedicaid: 'Medicaid',
            exchangeChip: 'CHIP',
            exchangeMedicaidOrChip: 'Medicaid or CHIP',
            exchangeMedicaidSlashChip: 'Medicaid/CHIP'
        },
        es: {
            exchangeName: 'Get Covered Illinois',
            exchangeMedicaid: 'Medicaid',
            exchangeChip: 'CHIP',
            exchangeMedicaidOrChip: 'Medicaid o CHIP',
            exchangeMedicaidSlashChip: 'Medicaid/CHIP'
        },
    },
    [states.MINNESOTA]: {
        en: {
            exchangeName: 'MNSure',
            exchangeMedicaid: 'Medical Assistance',
            exchangeChip: 'MinnesotaCare',
            exchangeMedicaidOrChip: 'Medical Assistance or MinnesotaCare',
            exchangeMedicaidSlashChip: 'Medical Assistance/MinnesotaCare',
        },
        es: {
            exchangeName: 'MNSure',
            exchangeMedicaid: 'Medical Assistance',
            exchangeChip: 'MinnesotaCare',
            exchangeMedicaidOrChip: 'Medical Assistance or MinnesotaCare',
            exchangeMedicaidSlashChip: 'Medical Assistance/MinnesotaCare',
        },
    },
    [states.NEVADA]: {
        en: {
            exchangeName: 'Nevada Health Link',
            exchangeMedicaid: 'Medicaid',
            exchangeChip: 'CHIP',
            exchangeMedicaidOrChip: 'Medicaid or CHIP',
            exchangeMedicaidSlashChip: 'Medicaid/CHIP',
        },
        es: {
            exchangeName: 'Nevada Health Link',
            exchangeMedicaid: 'Seguro de enfermedad',
            exchangeChip: 'CHIP',
            exchangeMedicaidOrChip: 'Seguro de enfermedad o CHIP',
            exchangeMedicaidSlashChip: 'Seguro de enfermedad/CHIP',
        },
    },
    [states.NEW_JERSEY]: {
        en: {
            exchangeName: 'GetCoveredNJ',
            exchangeMedicaid: 'NJ FamilyCare',
            exchangeChip: 'NJ FamilyCare',
            exchangeMedicaidOrChip: 'NJ FamilyCare',
            exchangeMedicaidSlashChip: 'NJ FamilyCare',
        },
        es: {
            exchangeName: 'GetCoveredNJ',
            exchangeMedicaid: 'NJ FamilyCare',
            exchangeChip: 'NJ FamilyCare',
            exchangeMedicaidOrChip: 'NJ FamilyCare',
            exchangeMedicaidSlashChip: 'NJ FamilyCare',
        },
    },
    [states.NEW_MEXICO]: {
        en: {
            exchangeName: 'BeWell',
            exchangeMedicaid: 'Medicaid',
            exchangeChip: 'Medicaid',
            exchangeMedicaidOrChip: 'Medicaid',
            exchangeMedicaidSlashChip: 'Medicaid',
        },
        es: {
            exchangeName: 'BeWell',
            exchangeMedicaid: 'Medicaid',
            exchangeChip: 'Medicaid',
            exchangeMedicaidOrChip: 'Medicaid',
            exchangeMedicaidSlashChip: 'Medicaid',
        },
    },
    [states.PENNSYLVANIA]: {
        en: {
            exchangeName: 'Pennie',
            exchangeMedicaid: 'Medicaid',
            exchangeChip: 'CHIP',
            exchangeMedicaidOrChip: 'Medicaid or CHIP',
            exchangeMedicaidSlashChip: 'Medicaid/CHIP',
        },
        es: {
            exchangeName: 'Pennie',
            exchangeMedicaid: 'Medicaid',
            exchangeChip: 'CHIP',
            exchangeMedicaidOrChip: 'Medicaid o CHIP',
            exchangeMedicaidSlashChip: 'Medicaid/CHIP',
        },
    },
    [states.VIRGINIA]: {
        en: {
            exchangeName: 'Virginia\'s Insurance Marketplace',
            exchangeMedicaid: 'Medicaid',
            exchangeChip: 'FAMIS',
            exchangeMedicaidOrChip: 'Medicaid or FAMIS',
            exchangeMedicaidSlashChip: 'Medicaid/FAMIS',
        },
        es: {
            exchangeName: 'Virginia\'s Insurance Marketplace',
            exchangeMedicaid: 'Medicaid',
            exchangeChip: 'FAMIS',
            exchangeMedicaidOrChip: 'Medicaid or FAMIS',
            exchangeMedicaidSlashChip: 'Medicaid/FAMIS',
        },
    },
    
};